import { mapKeys, camelCase, snakeCase } from "lodash";

export const getBank = (banklist, code) => {
  try {
    return (
      (banklist || []).find((bank) => {
        return bank.code === code;
      }) || {}
    );
  } catch (err) {
    return {};
  }
};

const logoUrl =
  "https://assets-emmsdan.herokuapp.com/api/logo/img/:company/png";
export const getCompanyLogo = (company) => {
  return logoUrl.replace(":company", company);
};

export const formatKeysToCamelCase = (obj) => {
  return mapKeys(obj, (v, k) => camelCase(k));
};

export const formatKeysToSnakeCase = (obj) => {
  return mapKeys(obj, (v, k) => snakeCase(k));
};
